import { useMutation } from '@tanstack/react-query'
import { changePassword } from '@/lib'

interface ChangePasswordParams {
  oldPassword: string
  newPassword: string
}

/**
 * パスワード変更を行うカスタムフック
 *
 * @returns TanStack Query の mutation 結果（mutate, mutateAsync, isPending, error など）
 */
export function useChangePassword() {
  return useMutation({
    mutationFn: async ({ oldPassword, newPassword }: ChangePasswordParams) => {
      return changePassword(oldPassword, newPassword)
    },
  })
}
